<template>
	<v-card flat rounded="lg" :class="['border', status ? `promo-step__status promo-step__status--${status}` : '']" @click="emit('open', campaign.id)">
		<div class="d-flex align-center ga-3 pa-4">
			<div class="flex-grow-1">
				<div class="d-flex align-center ga-2">
					<v-icon v-if="campaign.promoLocal" size="small">flag</v-icon>
					<div>
						<div class="text-title-small font-weight-bold">{{ campaign.label }}</div>
						<div v-if="subtitle" class="text-body-small text-medium-emphasis">{{ subtitle }}</div>
					</div>
				</div>
				<v-chip v-if="periodChip" color="primary" size="x-small" class="mt-2">{{ periodChip }}</v-chip>
			</div>
			<v-icon>chevron_right</v-icon>
		</div>
		<div class="px-4 pb-4">
			<PromoCampaignGauges :campaign="campaign" compact />
		</div>
	</v-card>
</template>

<script setup>
import { toRef } from 'vue';
import { usePromoCampaign } from '@/composables/usePromoCampaign';
import PromoCampaignGauges from './PromoCampaignGauges.vue';

const props = defineProps({
	campaign: { type: Object, required: true },
});
const emit = defineEmits(['open']);

const { status, subtitle, periodChip } = usePromoCampaign(toRef(props, 'campaign'));
</script>
